import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { PasswordInput } from "@/components/Layout";
import logo from "@/assets/HR.png";

/**
 * Hidden Superadmin login page.
 * Accesibil doar pe URL secret /sa-login — nu apare nicăieri în UI.
 * Doar utilizatorii cu rolul „superadmin" pot pătrunde din această cale.
 */
export default function SuperadminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const u = await login(username.trim().toLowerCase(), password);
      if (!u.role_names?.includes("superadmin")) {
        setError("Acces neautorizat");
        setLoading(false);
        return;
      }
      nav("/admin/licenses");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Autentificare eșuată");
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #050B1A 0%, #0A1930 100%)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <form onSubmit={submit} data-testid="sa-login-form" style={{
        width: 380, background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12,
        padding: 40, backdropFilter: "blur(20px)"
      }}>
        <div style={{ marginBottom: 30 }}>
          <img src={logo} alt="ONOMAD" style={{ height: 48, width: "auto", filter: "invert(1)", marginBottom: 16 }} />
          <div style={{ fontSize: 10, color: "#94A3B8", letterSpacing: "0.2em", textTransform: "uppercase" }}>Restricted Access</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "white", marginTop: 4, letterSpacing: "-0.02em" }}>Superadmin Console</div>
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={{ fontSize: 11, color: "#94A3B8", fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase" }}>Operator</label>
          <input value={username} onChange={e=>setUsername(e.target.value)} autoFocus autoComplete="username"
            data-testid="sa-username"
            style={{ width:"100%", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)",
              color:"white", padding:"10px 14px", borderRadius:6, fontSize:14, marginTop:4, outline:"none" }} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 11, color: "#94A3B8", fontWeight: 600, letterSpacing: "0.05em", textTransform: "uppercase" }}>Passphrase</label>
          <PasswordInput value={password} onChange={e=>setPassword(e.target.value)} autoComplete="current-password"
            testId="sa-password" className=""
            style={{ width:"100%", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)",
              color:"white", padding:"10px 14px", borderRadius:6, fontSize:14, marginTop:4, outline:"none" }} />
        </div>
        {error && (
          <div style={{ background:"rgba(220,38,38,0.15)", border:"1px solid rgba(220,38,38,0.3)",
            color:"#FCA5A5", padding:"8px 12px", borderRadius:6, marginBottom:14, fontSize:12 }} data-testid="sa-error">{error}</div>
        )}
        <button disabled={loading} data-testid="sa-submit" style={{
          width:"100%", padding:"12px 16px", background:"white", color:"#0A1930",
          border:"none", borderRadius:6, fontWeight:700, cursor: loading?"wait":"pointer",
          letterSpacing:"0.02em", fontSize:14 }}>
          {loading ? "Verificare..." : "Autentificare"}
        </button>
      </form>
    </div>
  );
}
